// Absolute boxes from computeLayout rects (client CSS px; every chrome rect comes from the layout, §2.6).
import type { JSX } from 'preact';
import type { Rect } from '../../layout/computeLayout.ts';

export const box = (r: Rect): JSX.CSSProperties => ({
  left: `${r.x}px`,
  top: `${r.y}px`,
  width: `${r.w}px`,
  height: `${r.h}px`,
});
